module.exports = __webpack_public_path__ + "static/img/mac2.a21e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hiw/mac2.png
// module id = 651
// module chunks = 1